// Blog comments data
// Comments are organized by post ID

export const blogComments = {
  // Post 1: Predictive Maintenance
  1: [
    {
      id: 101,
      author: 'Michael Torres',
      date: '2025-10-18',
      content: 'We implemented predictive maintenance at our 30MW site last year and saw similar results. The key was getting buy-in from the field technicians who initially were skeptical of "AI telling them what to do." Once they saw it actually helped them work smarter, not harder, everything clicked.',
      likes: 12
    },
    {
      id: 102,
      author: 'Jennifer Walsh',
      date: '2025-10-22',
      content: 'Really helpful breakdown of the ROI. I\'m presenting to our board next month on upgrading our monitoring systems and this gives me concrete numbers to work with. Do you have any data on implementation timelines?',
      likes: 8
    },
    {
      id: 103,
      author: 'David Kim',
      date: '2025-11-05',
      content: 'The 42% reduction in downtime is impressive. We\'re currently experiencing about 15 unplanned outages annually across our portfolio. Would love to learn more about how the anomaly detection handles different inverter brands.',
      likes: 5
    },
    {
      id: 104,
      author: 'Amanda Chen',
      date: '2025-11-15',
      content: 'Great article! Question: how does the system handle false positives? We tried a similar solution before and got alert fatigue from too many warnings that turned out to be nothing.',
      likes: 7
    }
  ],

  // Post 2: AI in Solar Monitoring
  2: [
    {
      id: 201,
      author: 'Robert Anderson',
      date: '2025-11-12',
      content: 'The self-healing systems you mention are fascinating. We\'re starting to see some of this with our newer string inverters that can isolate faulty strings automatically. The future is definitely heading toward more autonomy.',
      likes: 9
    },
    {
      id: 202,
      author: 'Lisa Patel',
      date: '2025-11-20',
      content: 'I appreciate the point about AI amplifying human expertise rather than replacing it. Too many vendors promise "fully autonomous operations" which isn\'t realistic for complex utility-scale plants.',
      likes: 14
    },
    {
      id: 203,
      author: 'Carlos Mendez',
      date: '2025-12-01',
      content: 'Curious about the data requirements for these AI systems. How much historical data do you need before the machine learning models become accurate? We have sites that are only 1-2 years old.',
      likes: 6
    }
  ],

  // Post 3: Key Metrics
  3: [
    {
      id: 301,
      author: 'Sarah O\'Brien',
      date: '2025-12-08',
      content: 'Finally, a straightforward explanation of which metrics actually matter! We were tracking 50+ KPIs and drowning in dashboards. Focusing on these five has made our morning standups much more productive.',
      likes: 11
    },
    {
      id: 302,
      author: 'Tom Nguyen',
      date: '2025-12-15',
      content: 'Good list, but I\'d add one more: clipping losses. For sites with high DC/AC ratios, understanding how much energy you\'re leaving on the table during peak hours can inform future design decisions.',
      likes: 8
    },
    {
      id: 303,
      author: 'Michelle Foster',
      date: '2025-12-22',
      content: 'The soiling loss rate recommendation of 0.1-0.5% daily seems about right for our desert installations. We use robotic cleaners now and they\'ve been a game-changer for keeping those losses in check.',
      likes: 4
    }
  ],

  // Post 4: Inverter Efficiency
  4: [
    {
      id: 401,
      author: 'Andrew Palmer',
      date: '2026-01-08',
      content: 'Excellent technical deep-dive. The capacitor aging issue is real - we\'ve started proactively replacing DC link capacitors at the 6-year mark and it\'s prevented several unexpected failures.',
      likes: 6
    },
    {
      id: 402,
      author: 'Rachel Greene',
      date: '2026-01-12',
      content: 'Would love to see a follow-up article on central vs. string inverter maintenance differences. We\'re transitioning from central to string on new builds and the O&M approach needs to be quite different.',
      likes: 3
    }
  ],

  // Post 5: ROI Analytics
  5: [
    {
      id: 501,
      author: 'Kevin Brooks',
      date: '2026-01-22',
      content: 'The Desert Sun case study numbers are compelling. 4.2% yield improvement is significant. How long did it take to see those results after implementing the platform?',
      likes: 5
    },
    {
      id: 502,
      author: 'Patricia Martinez',
      date: '2026-01-25',
      content: 'We\'re evaluating analytics platforms now and this article highlights exactly what we should be looking for. The financial impact quantification feature is key for getting executive buy-in.',
      likes: 2
    }
  ]
}

// Get comments for a specific post
export const getCommentsForPost = (postId) => {
  return blogComments[postId] || []
}

// Get total comment count for a post
export const getCommentCount = (postId) => {
  return (blogComments[postId] || []).length
}
